import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const createUsedBy = ( {data} : {data: IPostNewUsedBy | {}}): Promise<string> => {
  return axiosDefaultApi.post(`api/UsedBy/InsertUsedBy`, data);
};

type QueryFnType = typeof createUsedBy;

type UseCreateUsedByOptions = {
  data: IPostNewUsedBy | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateUsedBy = ({ config }: UseCreateUsedByOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία της παραμέτρου 'Χρήση από'.`, 500);
            console.error('Couldnt create new used by', error);
            setIsNotificationVisible(true)
          },
          onSuccess: (response) => {
            queryClient.invalidateQueries(["getAllUsedBy"])
            addNotification("Δημιουργήθηκε Νέα παράμετρος 'Χρήση από'.", 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createUsedBy,
    })
}